module.exports = __webpack_public_path__ + "img/brand-cliff.2707d0ae.png";